import { apiAction } from 'client/redux/apiHelpers';

export const resetPassword = (types, form) => {
  return apiAction({
    endpoint: '/api/user/resetPassword',
    method: 'POST',
    types,
    json: form,
  });
};
